'use client';
import React from 'react';
import { useGetEntityProfileConfigQuery } from 'src/api/redux';
import { useProfile } from 'src/context/providers/ProfileProvider';
import { TopLocationsSection } from 'src/components/Profiles/shared/widgets/TopLocationsSection';
import { TopProvidersSection } from 'src/components/Profiles/shared/widgets/TopProvidersSection';
import { WidgetGrid } from 'src/components/Profiles/shared/widgets/WidgetGrid';
// Side-effect import: registers the widget resolver
import 'src/components/Profiles/shared/profileWidgetConfig';
import { getEntityIdentifiers } from 'src/utils/getEntityIdentifiers';
import { EmptyState } from 'src/components/PulseUI';

const bodyOverrides: Record<string, React.ComponentType> = {
  top_providers_at_site: TopProvidersSection,
  top_locations: TopLocationsSection,
};

const ProfileDrawerConfigV3 = () => {
  const { entityDetails } = useProfile();
  const { providerId } = getEntityIdentifiers(entityDetails);

  const { data: profileConfig, isLoading } = useGetEntityProfileConfigQuery(
    { entityId: providerId },
    { skip: !providerId }
  );

  if (isLoading) {
    return (
      <div
        className="flex-1 flex justify-center items-center"
        data-testid="profile-drawer-config-v3-loading"
      >
        <p className="text-neutral-500">Loading profile configuration...</p>
      </div>
    );
  }

  if (!profileConfig) {
    return (
      <div
        className="flex-1 flex justify-center items-center px-6"
        data-testid="profile-drawer-config-v3-empty"
      >
        <EmptyState
          title="No profile configuration"
          description="Contact your Customer Success team member to have a profile configuration generated."
          size="md"
          className="border-none shadow-none bg-transparent"
        />
      </div>
    );
  }

  const widgets = profileConfig?.widgets ?? [];

  return (
    <div
      className="flex-1 min-h-0 overflow-y-auto flex flex-col gap-4 bg-neutral-100 py-4 px-4"
      data-testid="profile-drawer-config-v3"
    >
      <WidgetGrid
        widgets={widgets}
        columns={1}
        componentOverrides={bodyOverrides}
        testIdPrefix="drawer-widget"
      />
    </div>
  );
};

export default ProfileDrawerConfigV3;
